import { render } from "./MediaGallery.vue?vue&type=template&id=c6b65c44&ts=true"
import script from "./MediaGallery.vue?vue&type=script&lang=ts"
export * from "./MediaGallery.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/witteveenbos/witteveenbos-light-modules/corporate-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__